module.exports = __webpack_public_path__ + "img/transportation.e11bb425.png";